import React from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu } from 'antd';
import { connect } from "react-redux";
import {
  SettingTwoTone,
  IdcardTwoTone,
  SecurityScanTwoTone,
  FileTwoTone,
  RightSquareTwoTone
} from '@ant-design/icons';
const { Sider } = Layout;
const { SubMenu } = Menu;

const mapStateToProps = (state) => ({
  // ...state.home,
  users: state.users,
  currentUser: state.common.currentUser,
  // token: state.common.token
});
class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedKeys: '',
    };
    this.handleClickMenu = this.handleClickMenu.bind(this)
    this.handleClickLogo = this.handleClickLogo.bind(this)
  }

  handleClickMenu(e) {
    // console.log(e.key)
    this.setState({
      selectedKeys: e.key
    })
    // this.props.handleClickCancelSearch()
    this.props.handleClickMenu()
  }
  handleClickLogo(e) {
    // console.log(e)
    this.setState({
      selectedKeys: e
    })
  }

  render() {

    return (
      <Sider theme="light"
        width="200px"
        collapsible
        collapsed={this.props.collapsed} onCollapse={this.props.handleClickMenuArrow}
        id="sidebar" role="sidebar">
        <div className="logo" id="sidebarLogo" onClick={(e) => this.handleClickLogo('1')}>
          {
            this.props.collapsed === true ?
              <img src="./images/logo_2.svg" className="logo_single" /> :
              <img src="./images/logo_1.svg" />
          }
        </div>
        <Menu  theme="" mode="inline" defaultSelectedKeys={this.state.selectedKeys} id="sidebarMenu"
          defaultSelectedKeys={[
            this.props.location.includes('/report') ? '1' :
              this.props.location.includes('/users') ? '2' :
                this.props.location.includes('/settings') ? '3' : '1'
          ]}>
          {/* <Menu.Item key="1" icon={<SecurityScanTwoTone twoToneColor="#ff5b00" />} onClick={(e) => this.props.handleClickMenu('seachResult')}>
            <Link to="/seachResult">
              Seach Result
            </Link>
          </Menu.Item> */}
          <Menu.Item key="1" icon={<FileTwoTone twoToneColor="#ff5b00" />} onClick={(e) => this.props.handleClickMenu(e)}>
            <Link to="/report">
              Report
            </Link>
          </Menu.Item>
          <Menu.Item key="2" icon={<IdcardTwoTone twoToneColor="#ff5b00" />} onClick={(e) => this.handleClickMenu(e)}>
            <Link to="/users">
              Users
            </Link>
          </Menu.Item>
          {this.props.currentUser && this.props.currentUser.user_role === "Admin" && (
            <Menu.Item key="3" icon={<SettingTwoTone twoToneColor="#ff5b00" />} onClick={(e) => this.handleClickMenu(e)}>
              <Link to="/settings">
               Settings
              </Link>
            </Menu.Item>
          )}
          <Menu.Item key="4" icon={<RightSquareTwoTone twoToneColor="#ff5b00" />} onClick={(e) => this.props.handleClickLogout(e)}>
            <Link to="/login">
              Logout
            </Link>
          </Menu.Item>
        </Menu>
      </Sider>
    )
  }
}

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// src/components/Sidebar.js